import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createAssignment, completeAssignment } from '@/api/assignments';
import type { CreateAssignmentInput } from '@/types/assignment';

export function useCreateAssignment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateAssignmentInput) => createAssignment(input),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'assignments'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'overview'] });
      // Refresh the student detail page (assignments list + session stats).
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'students', vars.student_id] });
      // Refresh the seed detail page (times assigned, recent assignments).
      queryClient.invalidateQueries({ queryKey: ['seeds', vars.practice_seed_id] });
      queryClient.invalidateQueries({ queryKey: ['seeds'] });
    },
  });
}

export function useCompleteAssignment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => completeAssignment(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'assignments'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'overview'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'students'] });
    },
  });
}
